import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-remove-collaborator-with-devices.hbs';

    var RemoveCollaboratorWithDevicesDialog = Marionette.View.extend(DialogInterface).extend({
        id: 'remove-collaborator-with-devices',
        template: Handlebars.compile(template),
        initialize: function(options) {
            this.destroyOnClose();
            this.targetAccount = options.targetAccount;
            this.devices = options.devices;
        },
        serializeData: function() {
            var devices = _(this.devices).map(_.bind(function(device) {
                var model = this.targetAccount.models.findWhere({ id: device.get('model_id') });
                var modelName = model.get('name') || '';
                return {
                    id: device.id,
                    modelName: modelName
                };
            }, this));

            return {
                devices: devices,
                name: this.model.get('name')
            };
        }
    });
    export default RemoveCollaboratorWithDevicesDialog;

